import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SmilePointsService {
  constructor() {}

  convertPointsToAED(points, type, valueInAEDToBePaid) {
    var valueInAED = 0;
    var valueInPoints = parseFloat(points);
    var loyaltyMultiplier = 0;
    if (!isNaN(points)) {
      if (type == 'devices') {
        loyaltyMultiplier = 0.0085;
				let returnedValue = points * 0.0085;
				return {returnedValue: returnedValue, loyaltyMultiplier: loyaltyMultiplier};
      }
      if (valueInPoints <= 55555) {
        loyaltyMultiplier = 0.008;
        valueInAED = points * 0.008;
      } else if (55556 <= valueInPoints && valueInPoints <= 62499) {
        loyaltyMultiplier = 0.017002737;
        valueInAED = 0.017002737 * points - 500.164;
      } else if (62500 <= valueInPoints && valueInPoints <= 99999) {
        loyaltyMultiplier = 0.009;
        valueInAED = points * 0.009;
      } else if (100000 <= valueInPoints && valueInPoints <= 111110) {
        loyaltyMultiplier = 0.0190009;
        valueInAED = 0.0190009 * points - 1000.090009;
      } else if (valueInPoints >= 111111) {
        loyaltyMultiplier = 0.01;
        valueInAED = points * 0.01;
      }
    }
    var returnedValue = Math.floor(valueInAED * 100) / 100;
    if (
      returnedValue - valueInAEDToBePaid > 0.0 &&
      returnedValue - valueInAEDToBePaid <= 0.01
    ) {
      returnedValue = valueInAEDToBePaid;
    }
    return {returnedValue: returnedValue, loyaltyMultiplier: loyaltyMultiplier};
  }

  convertAEDToPoints(aed, type) {
    var valueInPoints = 0;
    var valueInAED = parseFloat(aed);
    if (!isNaN(aed)) {
      if (type == 'devices') {
        return aed / 0.0085;
      }
      if (valueInAED <= 444.43) {
        valueInPoints = aed / 0.008;
      } else if (444.44 <= valueInAED && valueInAED <= 562.49) {
        valueInPoints = aed * 58.814060348 + 29416.675679921;
      } else if (562.5 <= valueInAED && valueInAED <= 899.99) {
        valueInPoints = aed / 0.009;
      } else if (900 <= valueInAED && valueInAED <= 1111.1) {
        valueInPoints = 52.6290859907 * aed + 52633.823082064;
      } else if (valueInAED >= 1111.11) {
        valueInPoints = aed / 0.01;
      }
    }
    return Math.ceil(valueInPoints);
  }
}
